var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{staticClass:"plus-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"11","height":"11","viewBox":"0 0 24 24"}},[(_vm.title)?_c('title',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('path',{attrs:{"fill":"inherit","d":"M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }